import { mapGetters, mapActions } from "vuex";
import Dropdown from "@/components/dropdown/Dropdown.vue";
import Loader from "@/components/loader/Loader.vue";
import IconCam from "@/components/iconCam/IconCam.vue";
import Cam from "@/components/cam/Cam.vue";
import { mapObjSizes } from "@/consts/mapObjSizes";
import { getViewName } from "@/utils";

export default {
  name: "MapObject",
  components: {
    Dropdown,
    IconCam,
    Loader,
    Cam
  },
  props: {
    map: {
      type: Object,
      required: true
    },
    type: {
      type: String, // cam | object
      default: "cam"
    },
    scale: {
      type: String,
      required: true,
      validator: scaleType => ["S", "L"].includes(scaleType)
    },
    /**
     * объект камеры,
     * созданный после слияния объекта на карте
     * с type == 'CAM' и объекта камеры по запросу
     * cameras (fetchCams) (обязателен, если type === 'cam')
     */
    cam: {
      type: Object
    },
    /**
     * Другие объекты не являющиеся камерами (type !== 'CAM') -
     * обязателен, если type === 'object'
     */
    mapObject: {
      type: Object
    },
    limitWidthIcon: {
      type: Number,
      default: 20
    },
    /**
     * размеры иконки и расстояние между иконками на карте
     */
    styleWidthDistance: {
      type: Object,
      required: true
    },
    isHighlight: {
      type: Boolean
    },
    isIndicateAlarms: {
      type: Boolean
    }
  },
  data() {
    return {
      dataObjectLoading: false,
      dataObject: null
    };
  },
  computed: {
    ...mapGetters({
      alarmCams: "getAlarmCams"
    }),
    loading() {
      const { cam } = this;
      return (cam && cam.image === "loading") || false;
    },
    isDataLoaded() {
      if (this.type === "cam") {
        return this.cam.image && !this.loading;
      }
      return !this.dataObjectLoading;
    },
    isHaveImage() {
      return (
        this.type === "cam" &&
        ["DETACHED", "DISARM_DETACHED"].indexOf(this.cam.status.state) < 0
      );
    },
    image() {
      const { cam } = this;
      if (!cam) return null;
      return cam.image || cam.lastImage || null;
    },
    isLastImage() {
      const { cam } = this;
      if (!cam) return false;
      return (!cam.image && cam.lastImage) || false;
    },
    isViewCamera() {
      const { isDataLoaded, isHaveImage, dataObject } = this;
      return (
        isDataLoaded && (isHaveImage || (dataObject && dataObject.cameras))
      );
    },
    isRefresh() {
      const { isHaveImage, loading } = this;
      return !loading && isHaveImage;
    },
    imageDate() {
      const { image, loading, cam } = this;
      return (!loading && image && cam.imageDate) || null;
    },
    objectFontSize() {
      return {
        fontSize: mapObjSizes[this.scale].cam.fontSize + "px"
      };
    }
  },
  created() {
    if (this.type === "object") {
      this.fetchObject();
    }
  },
  methods: {
    ...mapActions({
      getObject: "getObject"
    }),
    getImage() {
      if (this.isHaveImage) {
        this.$store.dispatch("getCamImage", this.cam.id);
      }
    },
    fetchObject() {
      this.dataObjectLoading = true;
      this.getObject({
        type: this.mapObject.type,
        id: this.mapObject.id
      }).then(res => {
        this.dataObject = res;
        this.dataObjectLoading = false;
      });
    },
    onDropdownOpen(event) {
      if (event) {
        if (this.type === "cam") {
          this.getImage();
        } else {
          this.fetchObject();
        }
      }
    },
    viewCam() {
      if (this.type === "cam") {
        this.$router.push({
          name: "views",
          params: {
            viewId: "main",
            mapGroupId: this.map.group.id,
            mapId: this.map.id,
            camId: this.cam.id
          }
        });
      } else {
        this.$store.commit("addCamsIntoView", {
          camIds: this.dataObject.cameras.split(","),
          viewId: "main"
        });
        this.$router.push({
          name: "views",
          params: {
            viewId: "main"
          }
        });
      }
    },
    getViewName
  }
};



// WEBPACK FOOTER //
// ./src/components/map-object/map-object.js